// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"158aaaa5","453":"ea7e40bb","876":"d73872a0"}[chunkId] + ".chunk.js";
};